/**
 * Calendar 活動適配器（預留）
 * 為未來的 Calendar 場景預留介面
 */

import { BaseAdapter } from './baseAdapter';

export class CalendarAdapter extends BaseAdapter {
  /**
   * 檢查當前環境是否支援 Calendar 適配器
   * @returns {boolean}
   */
  isSupported() {
    // TODO: 實作 Calendar 環境檢查
    return typeof Office !== 'undefined' && 
           Office.context && 
           Office.context.mailbox && 
           Office.context.mailbox.item &&
           Office.context.mailbox.item.itemType === Office.MailboxEnums.ItemType.Appointment;
  }

  /**
   * 獲取適配器名稱
   * @returns {string}
   */
  getName() {
    return 'Calendar';
  }

  /**
   * 新增與會人員到 Calendar 活動
   * @param {Array} recipients - 與會人員列表，格式：[{displayName: string, emailAddress: string}]
   * @param {string} type - 類型："attendees"（Calendar 只有一種類型）
   * @returns {Promise<void>}
   */
  async addRecipients(recipients, type) {
    if (!this.isSupported()) {
      throw new Error('Calendar context is not available');
    }

    // TODO: 實作 Calendar 的與會人員新增邏輯
    // 這需要根據 Office.js Calendar API 來實作
    // 目前先拋出錯誤，提示功能尚未實作
    
    const uniqueRecipientMap = new Map();
    recipients.forEach((r) => {
      const email = r.emailAddress;
      if (!uniqueRecipientMap.has(email)) {
        uniqueRecipientMap.set(email, r);
      }
    });
    const uniqueRecipients = Array.from(uniqueRecipientMap.values());
    if (uniqueRecipients.length === 0) {
      console.warn("No valid recipients found.");
      return;
    }

    return new Promise((resolve, reject) => {
      const item = Office.context.mailbox.item;
      let addMethod;
      
      switch (type) {
        case 'requiredAttendees':
          addMethod = item.requiredAttendees.addAsync.bind(item.requiredAttendees);
          break;
        case 'optionalAttendees':
          addMethod = item.optionalAttendees.addAsync.bind(item.optionalAttendees);
          break;
        default:
          reject(new Error(`Invalid message type: ${type}`));
          return;
      }

      addMethod(uniqueRecipients, (asyncResult) => {
        if (asyncResult.status === Office.AsyncResultStatus.Failed) {
          reject(new Error(asyncResult.error.message));
        } else {
          console.log("Recipients added successfully.");
          resolve();
        }
      });
    })
  
  }
}

